import { Group, Text } from '@apollo/orbit';
import React from 'react';

import { Icon as IconGalaxy } from 'src/assets/icon-galaxy.svg';

export const EmptyState = ({ message }: { message: string }) => (
  <Group
    orientation="vertical"
    justify="center"
    align="start"
    gap={4}
    className="my-12"
  >
    <IconGalaxy />
    <Text>{message}</Text>
  </Group>
);
